import Api from 'libs/api/index';

class CompanyChildCategories extends Api {
  constructor() {
    super('admin/company_child_categories/');
  }
}

export default CompanyChildCategories;
